module.exports = __webpack_public_path__ + "fonts/db9c0c6.ttf";